import PublicationForm from './PublicationForm';

export default PublicationForm;
